module.exports = __webpack_public_path__ + "eec08f8b9c6764b8629693c89b28aa83.png";